module.exports = __webpack_public_path__ + "img/banner1.3e95b6aa.png";